import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./wishlist.css";
import { useNotification } from "../Notification/notification";
import Header, { Footer } from "../HomePage/header";

export default function Wishlist() {
  const [wishlistItems, setWishlistItems] = useState([]);
  const { notify } = useNotification();

  const loadWishlist = () => {
    const stored = JSON.parse(localStorage.getItem("wishlist")) || [];
   const normalized = stored.map((item) => ({
  id: item.id || item.productId,
  productName: item.productName || item.name,
  productPrice: item.productPrice || item.price,
  productImage: item.productImage || item.image,
}));
    setWishlistItems(normalized);
  };

  useEffect(() => {
    loadWishlist();
  }, []);

  useEffect(() => {
    const handleStorageChange = () => loadWishlist();
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleRemove = (id, showNotify = true) => {
    const updated = wishlistItems.filter(
      (item) => String(item.id) !== String(id),
    );
    setWishlistItems(updated);
    localStorage.setItem("wishlist", JSON.stringify(updated));

    if (showNotify) notify("Item removed from wishlist", "error");
  };

  const handleMoveToCart = (item) => {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const exists = cart.some((p) => String(p.id) === String(item.id));

    if (!exists) {
      cart.push(item);
      localStorage.setItem("cart", JSON.stringify(cart));
      notify("Moved to cart", "success");
      handleRemove(item.id, false);
    } else {
      notify("Already in cart", "warning");
    }
  };
  return (
    <>
      <Header />

      <div className="wishlist-container">
        <div className="wishlist-header">
          <h1>My Wishlist</h1>
          <p>Keep track of saved products and move them to cart anytime.</p>
        </div>

        {wishlistItems.length === 0 ? (
          <div className="wishlist-empty-state">
            <h2>Your wishlist is empty</h2>
            <p>Browse products and save items you want to buy later.</p>
            <Link to="/product" className="continue-btn">
              Explore Products
            </Link>
          </div>
        ) : (
          <>
            <div className="wishlist-grid">
              {wishlistItems.map((item) => (
                <div className="wishlist-card" key={item.id}>
                  <img src={item.productImage} alt={item.productName} />
                  <h3>{item.productName}</h3>
                  <p>Rs {item.productPrice}</p>

                  <div className="wishlist-buttons">
                    <button
                      className="move-btn"
                      onClick={() => handleMoveToCart(item)}
                    >
                      Move to Cart
                    </button>

                    <button
                      className="remove-btn"
                      onClick={() => handleRemove(item.id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/" className="continue-btn">
              Continue Shopping
            </Link>
          </>
        )}
      </div>

      <Footer />
    </>
  );
}
